import React from 'react';
import styled from 'styled-components';
import Mascot from '../Mascot';
import { useTranslation } from 'react-i18next';
import Tooltip from '../ui/Tooltip';

const Button = styled.button`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.15s;
  position: relative;

  &:hover {
    transform: scale(1.1);
    background: rgba(2, 145, 239, 0.08);
  }
`;

const IconWrap = styled.span`
  width: 34px;
  height: 34px;
  display: block;
`;

// Bu ipucu ELDE ÖRÜLMEZ. Daha önce butonun içinde `position: absolute; z-index: 10`
// bir <span>'dı; öyle bir kutu en yakın ata yığın bağlamına hapsolur ve ata
// `overflow` kutularıyla kırpılır — başlıktan taşıp Main'e (overflow-y: auto)
// girdiği için panel kartlarının ALTINDA kalıyordu. Paylaşılan `ui/Tooltip`
// kutuyu `document.body`'ye portal'lar (position: fixed, z-index 99999), yani her
// ata bağlamdan kaçar. Daha büyük bir z-index çözüm DEĞİLDİR: bir sonraki daha
// büyük değerde aynı hata geri gelir.
export default function AiChatButton({ onClick }) {
  const { t } = useTranslation();

  return (
    <Tooltip text={t('aiChat.title')} position="bottom">
      <Button onClick={onClick} type="button">
        <IconWrap><Mascot /></IconWrap>
      </Button>
    </Tooltip>
  );
}
